// ===================================================================
// PHOENIX OS — SERVIÇO DE PARECER COM IA (lado do app)
// ===================================================================
// Mesmo padrão do asaasService.js: este arquivo só CHAMA a Cloud
// Function — nunca fala direto com a Anthropic, nunca vê a chave.
// Vai em src/services/parecerIAService.js (mesma pasta do firebase.js).
// ===================================================================

import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase'; // ajuste o caminho se necessário

const functions = getFunctions(app, 'southamerica-east1');

/**
 * Chama a IA pra gerar o parecer. Retorna o texto já pronto (a Cloud
 * Function também salva no Firestore, então isso é só pra atualizar a
 * tela na hora, sem esperar o próximo onSnapshot).
 *
 * @param {string} dossieId - ID do documento em 'cenarios'
 * @param {'Gestor'|'Consultor'} tipoUsuario
 * @param {string} nicho - ex: "restaurante vegano premium"
 * @param {object} metricas - { ebitda, currentMargin, alavancagem, ... }
 * @param {Array} projecao - saída de calculateStochasticProjection()
 * @param {string[]} blocosProjecao - quais blocos de projeção gerar:
 *   subconjunto de ['curto','medio','longo'] — calculado a partir do
 *   plano atual (escalonamento: Tactical só 'curto', Plus +'medio',
 *   Total +'longo'). Cada bloco só é escrito pela IA se estiver aqui —
 *   nunca gera prazo que o plano não libera.
 * @param {boolean} incluirOportunidades - true só pro plano Total/Enterprise.
 * @param {boolean} apenasComplementar - true quando é só um "top-up" de
 *   bloco novo (upgrade de plano), sem regerar parecer nem oportunidades
 *   que já existem e não mudaram.
 */
export async function gerarParecerIA({ dossieId, tipoUsuario, nicho, metricas, projecao, inputSnapshot, blocosProjecao, incluirOportunidades, apenasComplementar }) {
    const chamar = httpsCallable(functions, 'gerarParecerIA');
    const resultado = await chamar({ dossieId, tipoUsuario, nicho, metricas, projecao, inputSnapshot, blocosProjecao, incluirOportunidades, apenasComplementar });
    return resultado.data;
}